import React, {Component} from 'react';

import view from '../images/settings-screen.jpg';
import view2 from '../images/settings-screen-schedule.jpg';
import { ItemChooser, Button } from '../components/FormUI';

import SettingsScheduling from './Settings/SettingsScheduling';
import SettingsAppointment from './Settings/SettingsAppointment';

import BigDateSelector from '../components/BigDateSelector';
import { Checkbox } from 'semantic-ui-react';

import './SettingsView.css';

export default class SettingsView extends Component{
    state = {view:'apps', scheduleMode:'exceptions'};

    constructor(props){
        super(props);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    handleDateChange(date){
        this.setState({date:date});
    }

    /*componentDidMount(){
        //console.log('Calendar View did Mount!!!!!!!!!!!')
        if(this.props.onSectionHeader){
            this.props.onSectionHeader(
                <div className='settings-section-header'>
                    <ItemChooser className='setting-section-chooser inline' value={this.state.view} onChange={ (s) => this.setState({view:s})}>
                        <Button caption='Appointments' itemId='apps' />
                        <Button caption='Scheduling' itemId='schedule' />
                    </ItemChooser>
                    <BigDateSelector format="MMMM YYYY" onChange={this.handleDateChange} date={this.state.date} />
                </div>
            )
        }
    }*/

    handleScheduleModeToggle = (e, { checked })=>{
        this.setState({scheduleMode: checked? 'exceptions':'defaults'})
    }

    handleModeChange = (m) => {
        this.setState({scheduleMode: m});
    }

    render(){

        if(this.props.onSectionHeader){
            this.props.onSectionHeader(
                <div className='settings-section-header'>
                    <ItemChooser className='setting-section-chooser inline' value={this.state.view} onChange={ (s) => this.setState({view:s})}>
                        <Button caption='Appointments' itemId='apps' />
                        <Button caption='Scheduling' itemId='schedule' />
                    </ItemChooser>
                    {this.state.view === 'schedule'? <ScheduleHeader mode={this.state.scheduleMode} onModeToggle={this.handleScheduleModeToggle} onChange={this.handleDateChange} date={this.state.date} /> : null}
                </div>
            )
        }


        switch (this.state.view) {
            case 'schedule':
                return <SettingsScheduling clinicId={this.props.clinicId} date={this.state.date} mode={this.state.scheduleMode} changeMode={this.handleModeChange} />
            break;
        
            default:
                return <SettingsAppointment clinicId={this.props.clinicId} date={this.state.date} />
            break;
        }       
    }
}

class ScheduleHeader extends Component{

    

    render(){

        if(this.props.mode === 'hourPrefs'){
            return null;
        }

        return(            
            <div className='table inline align-middle vmax'>
                <div>
                    {(this.props.mode == 'exceptions')? <div>
                        <BigDateSelector format="MMMM YYYY" {...this.props} />
                    </div>:<h3>Edit Default Schedule</h3>}
                    <div>
                        <Checkbox className='mode-toggle' checked={this.props.mode == 'exceptions'} onChange={this.props.onModeToggle} toggle /><span className="tiny">{this.props.mode == 'exceptions'? 'Switch To Defaults':'Switch to Exceptions'}</span>
                    </div>
                </div>
                
            </div>           
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/SettingsView.js